import styled from 'styled-components'

export const Button = styled.label`
    background: var(--color-button-primary);
    width: 200px; 
    padding: 8px 16px; 
    border-radius: 8px;
    border: none;
    color: var(--color-text-on-primary);
    font-size: 16px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
`

export const DisabledButton = styled(Button)`
  opacity: 0.5;
  cursor: not-allowed;
`

export const HeaderWrap = styled.div`
    display: flex;
    width: 100%; 
    border-bottom: 1px solid var(--color-issabeline-grey);
    margin-top: 10px;
    align-items: center;
    padding: 0 24px;
`

export const Header = styled.div`
    font-size: 14px;
    color: var(--color-pale-sky);
    text-align: left;
`


export const File = styled.input`
  display: none;
`

export const UploadForm = styled.div`
    width: 100%;
    background-color: var(--color-white);
    padding: 24px;
    border-radius: 10px;
    box-shadow: 4px 4px 29px rgba(19, 69, 186, 0.0855129);
    margin-top: 32px;
    margin-bottom: 16px;
    position: relative;
    display: flex;
    flex-direction: column; 
    gap: 16px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; 
`

export const PreviewWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-white);
`


